/* global axios */
import ApiClient from '../ApiClient';

class AidexacxInboxes extends ApiClient {
  constructor() {
    super('aidexacx/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/inboxes`);
  }

  create(params = {}) {
    const { assistantId, inboxId } = params;
    return axios.post(`${this.url}/${assistantId}/inboxes`, {
      inbox: { inbox_id: inboxId },
    });
  }

  delete(params = {}) {
    const { assistantId, inboxId } = params;
    return axios.delete(`${this.url}/${assistantId}/inboxes/${inboxId}`);
  }

  update(params = {}) {
    const { assistantId, inboxId, autoReply } = params;
    return axios.patch(`${this.url}/${assistantId}/inboxes/${inboxId}`, {
      auto_reply: autoReply,
    });
  }
}

export default new AidexacxInboxes();
